import React from 'react'
import { Routes, Route } from 'react-router-dom'

import Home from './Home'
import Project from './Project'
import Projects from './Projects'
import NotFound from './NotFound'
import About from './About'
import PhotoProjects from './PhotoProjects'
import PhotoProject from './PhotoProject'

export default function RouterPage() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/work" element={<Projects />} />
            <Route path="/project/:id" element={<Project />} />
            {/* <Route path="/photos" element={<PhotoProjects />} /> */}
            {/* <Route path="/photos/:id" element={<PhotoProject />} /> */}
            {/*   <Route path="/film" element={<Film />} />
            <Route path="/random" element={<Random />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/data-protection" element={<DataProtection />} />
            {/* todo limit projects in list for roouter */}a
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}